import axios from 'axios';
import { v4 } from 'uuid';
import Cookies from 'js-cookie';

import { FunctionProps, UnwrapPromise } from '@utils/types';
import { ServiceRegistry, Service } from '@api/service-registry';
import { normalizeApiErrors } from '@utils/api/customErrorHandler';

import { createUUID } from './core/request';

export const getRequestHeaders = (
  authorization?: string
): Record<string, string> => {
  const token =
    typeof window !== 'undefined'
      ? authorization ||
        Cookies.get('token') ||
        localStorage.getItem('token') ||
        createUUID('token', false, false)
      : authorization || createUUID('token', false, false);

  const basketId =
    typeof window !== 'undefined' && localStorage.getItem('basketId');
  const cid = v4();

  const headers: Record<string, string> = {
    token,
    authorization: token,
    correlationId: cid,
    ...(basketId && { basketId }),
  };

  return headers;
};

export async function callService<
  S extends Service,
  M extends FunctionProps<ServiceRegistry[S]> = FunctionProps<
    ServiceRegistry[S]
  >
>(
  Service: S,
  method: M,
  ...args: ServiceRegistry[S][M] extends (...args: infer Args) => unknown
    ? Args extends [infer First, ...infer Rest]
      ? [First, ...Rest]
      : Args
    : never
) {
  const hostname =
    typeof window !== 'undefined' ? '' : process.env.NEXT_PUBLIC_HOST;

  const token = args?.[0]?.['authorization'] ?? '';
  const path = `${hostname}/api/services/${Service}/${method as string}`;
  const headers = getRequestHeaders(token);

  let result: UnwrapPromise<ServiceRegistry[S][M]>;
  try {
    const { data } = await axios.post<UnwrapPromise<ServiceRegistry[S][M]>>(
      path,
      { args },
      { headers }
    );

    result = data;
  } catch (e) {
    result = (e as any).response.data as UnwrapPromise<ServiceRegistry[S][M]>;
  }
  return normalizeApiErrors(result);
}
